import { InjectionToken } from '@angular/core';
import { LoginService, NavService } from './app/QualityBidders/services';

export const InjectionTokens = new Map<any, any>([
  [NavService, new InjectionToken<NavService>('NAV_SERVICE')],
  [LoginService, new InjectionToken<LoginService>('LOGIN_SERVICE')],
]);
